module.exports = __webpack_public_path__ + "static/PublicShare2x-4d066898103a34f6616f8d8666642d01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/marvel-vs-zeplin/PublicShare2x.jpg
// module id = 2668
// module chunks = 21098653631116